import React from 'react';
function CreditCard({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20.182 5H3.818C2.814 5 2 5.784 2 6.75v10.5c0 .966.814 1.75 1.818 1.75h16.364C21.186 19 22 18.216 22 17.25V6.75C22 5.784 21.186 5 20.182 5zM2 11h20"
      />
    </svg>
  );
}

export default CreditCard;
